var React = require('react');

function Z1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Z1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"2.23 23.07 31.23 23.07 47.15 0 2.23 0 2.23 23.07","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"36.47 58.93 65.55 3.76 40.86 2.13 0 79.65 18.23 80.85 24.69 81.28 63.05 83.8 64.56 60.77 36.47 58.93","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Z1.defaultProps = {"viewBox":"0 0 65.55 83.8"};

module.exports = Z1;

Z1.default = Z1;
